import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { makeBookingManagerApi } from '../BookingManagerApi';
import { AncillaryRegionsSearchResponse } from '../types/AncillaryService';
import { MINUTES } from 'utils';

export const useHotelRegions = (countryCode?: string | null) => {
  const regions = useQuery<AncillaryRegionsSearchResponse[], AxiosError>({
    queryKey: ['hotelAdmin', 'regions', countryCode || ''],
    queryFn: async () => {
      if (!countryCode) {
        return [];
      }

      const response = await makeBookingManagerApi().getRegions(countryCode);
      return response.data;
    },
    enabled: !!countryCode,
    staleTime: 5 * MINUTES,
  });

  return {
    regionsData: regions.data || [],
    isLoadingRegionsData: regions.isLoading,
    isErrorRegionsData: regions.isError,
  };
};
